import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Listing } from '../../../classes/listing';

@Component({
  selector: 'app-more-to-see',
  templateUrl: './more-to-see.component.html',
  styleUrls: ['./more-to-see.component.scss']
})
export class MoreToSeeComponent implements OnInit {
  @Input() readonly listing: Listing;
  @Input() readonly showMap: boolean;
  @Input() readonly hasPoi: boolean;
  @Output() showExpandedGalleryView: EventEmitter<void> = new EventEmitter();
  @Output() goToPoi: EventEmitter<void> = new EventEmitter();
  @Output() toggleMap: EventEmitter<void> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

}
